import React, { useCallback } from 'react';
import { useDrag } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import { bound } from '@/utils/bound';
import { ImageViewerSliderItem } from '../image-viewer-slider-item';
import { Footer } from '../footer';
import { useIndex } from './hooks/useIndex';
import './index.scss';
const classPrefix = 'cn-ui-m-image-viewer-slider';
export const ImageViewerSlider = (props) => {
    const { value, onTap } = props;
    console.log('props.index', props.index);
    const { index, setIndex } = useIndex({
        index: props.index || 0,
        setIndex: props.setIndex,
    });
    const count = value.length;
    const slideWidth = window.innerWidth + 16;
    const [{ x }, api] = useSpring(() => ({
        x: index * slideWidth,
        config: { tension: 250, clamp: true },
    }));
    const swipeTo = useCallback((_index, immediate = false) => {
        setIndex(_index);
        const i = _index % count;
        api.start({
            x: i * slideWidth,
            immediate,
        });
    }, [api, count, setIndex, slideWidth]);
    const bind = useDrag((state) => {
        const [offsetX] = state.offset;
        if (state.last) {
            const minIndex = Math.floor(offsetX / slideWidth);
            const maxIndex = minIndex + 1;
            const velocityOffset = Math.min(state.velocity[0] * 2000, slideWidth) * state.direction[0];
            swipeTo(bound(Math.round((offsetX + velocityOffset) / slideWidth), minIndex, maxIndex));
        }
        else {
            api.start({
                x: offsetX,
                immediate: true,
            });
        }
    }, {
        transform: ([_x, _y]) => [-_x, _y],
        from: () => [x.get(), 0],
        bounds: () => {
            return {
                left: 0,
                right: (count - 1) * slideWidth,
            };
        },
        rubberband: true,
        axis: 'x',
        pointer: { touch: true },
    });
    console.log('index', index);
    return (React.createElement("div", { className: classPrefix, ...bind() },
        React.createElement(animated.div, { className: `${classPrefix}-content`, style: { x: x.to((_x) => -_x) } }, value.map((item) => (React.createElement(ImageViewerSliderItem, { key: item, value: item, onTap: onTap })))),
        React.createElement(Footer, { index: index, value: value, swipeTo: swipeTo })));
};
